import Img11 from "../assets/img/aqua/11.webp";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import Image1 from "../assets/img/1.jpg";
import Image2 from "../assets/img/2.jpg";
import Image3 from "../assets/img/3.jpg";
import Image4 from "../assets/img/4.jpg";
import Image5 from "../assets/img/5.jpg";
import Image6 from "../assets/img/6.jpg";
import Image7 from "../assets/img/7.jpeg";
import Image8 from "../assets/img/8.jpg";
import Image9 from "../assets/img/9.jpg";
// import RegistrationSection from "./RegistrationSection";
import Image10 from "../assets/img/10.png";
import Image11 from "../assets/img/11.jpg";
import Image12 from "../assets/img/12.jpg";
import Image13 from "../assets/img/13.jpg";
import Image14 from "../assets/img/14.png";
import Image15 from "../assets/img/15.jpg";
import Image16 from "../assets/img/16.png";
import Image17 from "../assets/img/17.png";
import Image18 from "../assets/img/18.jpg";
import Image19 from "../assets/img/19.jpg";
import Image20 from "../assets/img/20.jpg";
import Image21 from "../assets/img/21.png";
import Image22 from "../assets/img/22.jpg";
import Image23 from "../assets/img/23.jpg";
import Image24 from "../assets/img/24.png";
import Image25 from "../assets/img/25.jpeg";
import Image26 from "../assets/img/26.jpg";

import AQUA_LOGO from "../assets/img/aqua_logo_v2.png";
import Sponsors from "./Sponsors";
import SessionInfo from "./SessionInfo";
import HowToReach from "./HowReach";
import LocationMap from "./LocationMap";
import MahabalipuramPlaces from "./MahabalipuramPlaces";
// import FloatingRegisterButton from "./FloatingRegisterButton";
import { useRef } from "react";
import AquaIndiaBanner from "./AquaIndiaBanner";
const sliderImages = [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
  Image9,
  Image10,
  Image11,
  Image12,
  Image13,
  Image14,
  Image15,
  Image16,
  Image17,
  Image18,
  Image19,
  Image20,
  Image21,
  Image22,
  Image23,
  Image24,
  Image25,
  Image26,
];
export default function AquaIndiaSolidBrandPage() {
  function BenefitCell({ value, tier }) {
    const getStyle = () => {
      if (value === "✓") {
        return "inline-flex items-center justify-center w-8 h-8 bg-green-100 text-green-600 rounded-full font-bold";
      }
      if (value === "No") {
        return "inline-flex items-center justify-center w-8 h-8 bg-red-100 text-red-500 rounded-full font-bold text-sm";
      }
      return "inline-block bg-gradient-to-r from-[#785dd7] to-[#674ecf] text-white px-3 py-1 rounded-full font-bold text-sm";
    };

    return <div className={getStyle()}>{value === "No" ? "✗" : value}</div>;
  }

  const registrationRef = useRef(null);

  function scrollToRegistration() {
    registrationRef.current?.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <div className="min-h-screen text-slate-800 bg-white">
      {/* <FloatingRegisterButton clickAction={scrollToRegistration} /> */}
      {/* Minimal keyframes */}
      <style>{`
        @keyframes floaty { 0%,100%{ transform: translateY(0) translateX(0)} 33%{ transform: translateY(-10px) translateX(8px)} 66%{ transform: translateY(8px) translateX(-6px)} }
        .animate-floaty { animation: floaty 7s ease-in-out infinite; }
        @keyframes fadeup { from{ opacity:0; transform: translateY(16px)} to{ opacity:1; transform: translateY(0)} }
        .animate-fadeup { animation: fadeup .6s both; }
      `}</style>

      <div className="w-full h-full xl:h-[200px] 2xl:h-[200px] 3xl:h-[250px] 4xl:h-[280px] 5xl:h-[320px] overflow-hidden">
        <Swiper
          modules={[Autoplay, EffectFade, Navigation, Pagination]}
          spaceBetween={0}
          slidesPerView={1}
          effect="fade"
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={true}
          speed={800}
          navigation={false}
          className="w-full h-full"
        >
          {sliderImages.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="relative w-full h-full flex items-center justify-center">
                <img
                  src={image}
                  alt={`Slide ${index + 1}`}
                  className="w-full h-full  lg:object-cover xl:object-cover 2xl:object-cover 3xl:object-cover 4xl:object-cover 5xl:object-cover  object-contain"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <AquaIndiaBanner />
      <Sponsors />
      {/* <div ref={registrationRef}>
        <RegistrationSection Img11={Img11} />
      </div> */}
      <div className="flex justify-center mt-24">
        <img
          src={AQUA_LOGO}
          className="w-[200px] md:w-[380px] object-contain"
          alt="Aqua India Logo"
        />
      </div>
      <SessionInfo />
      <HowToReach />
      <div className="p-8">
        <h1 className="md:text-3xl text-xl text-center text-black font-bold mb-4">
          Event Location: Mahabalipuram
        </h1>
        <LocationMap />
      </div>

      <MahabalipuramPlaces />
      {/* Contact */}
      <section
        id="contact"
        className="relative overflow-hidden bg-gradient-to-br from-[#785dd7] via-[#6b4ecf] to-[#5a42b8] py-20 text-white"
      >
        {/* Background decorative elements */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 h-48 w-48 rounded-full bg-white blur-3xl"></div>
          <div className="absolute bottom-32 right-32 h-64 w-64 rounded-full bg-[#17254e] blur-3xl"></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-96 w-96 rounded-full bg-gradient-to-r from-white/5 to-[#17254e]/10 blur-3xl"></div>
        </div>

        <div className="container relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Enhanced Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur-sm px-6 py-3 text-sm font-semibold text-white/80 mb-6 border border-white/20">
              <span className="text-xl">📞</span>
              <span>Get in Touch</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              <span className="bg-gradient-to-r from-white via-[#e0f7fa] to-white bg-clip-text text-transparent">
                Contact Information
              </span>
            </h2>
            <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
              Ready to partner with us or need more information? Our team is
              here to help you every step of the way.
            </p>
            <div className="w-32 h-1 bg-gradient-to-r from-white to-[#e0f7fa] mx-auto rounded-full mt-6"></div>
          </div>

          {/* Contact Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
            {[
              {
                icon: "👤",
                title: "General Secretary",
                primary: "D. Vijay Anand",
                secondary: "Society of Aquaculture Professionals",
                details: [
                  "3, PKM Cross Street",
                  "Mel Ayanambakkam",
                  "CHENNAI 600 095 INDIA",
                ],
                gradient: "from-blue-500 to-blue-600",
                hoverGradient: "from-blue-600 to-blue-700",
              },
              {
                icon: "📞",
                title: "Phone Contact",
                primary: "+91 94432 46447",
                secondary: "Direct Line Available",
                details: [
                  "Sponsorship Inquiries",
                  "Registration Support",
                  "Event Information",
                ],
                gradient: "from-green-500 to-green-600",
                hoverGradient: "from-green-600 to-green-700",
                clickable: "tel:+919443246447",
              },
              {
                icon: "✉️",
                title: "Email Contact",
                primary: "gensec@aquaprofessional.org",
                secondary: "contact@aquaprofessional.org",
                details: [
                  "Official Correspondence",
                  "Detailed Inquiries",
                  "Partnership Proposals",
                ],
                gradient: "from-orange-500 to-orange-600",
                hoverGradient: "from-orange-600 to-orange-700",
                clickable: "mailto:gensec@aquaprofessional.org",
                isEmail: true, // Add this flag for special email handling
              },
              {
                icon: "🌐",
                title: "Website",
                primary: "societyofaquacultureprofessionals.org",
                secondary: "Official Website",
                details: [
                  "Latest Updates",
                  "Event Announcements",
                  "Resource Library",
                ],
                gradient: "from-purple-500 to-purple-600",
                hoverGradient: "from-purple-600 to-purple-700",
                clickable: "https://societyofaquacultureprofessionals.org/",
              },
            ].map((contact, index) => (
              <div key={index} className="group relative">
                {/* Card glow effect */}
                <div
                  className={`absolute inset-0 bg-gradient-to-r ${contact.gradient} rounded-3xl blur opacity-20 group-hover:opacity-30 transition-opacity duration-300`}
                ></div>

                <div className="relative bg-white/95 backdrop-blur-sm rounded-3xl p-6 h-full shadow-xl border border-white/20 group-hover:shadow-2xl transition-all duration-300 group-hover:-translate-y-1">
                  {/* Icon and Title */}
                  <div className="text-center mb-6">
                    <div
                      className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br ${contact.gradient} group-hover:bg-gradient-to-br group-hover:${contact.hoverGradient} rounded-2xl mb-4 shadow-lg transition-all duration-300 group-hover:scale-110`}
                    >
                      <span className="text-2xl">{contact.icon}</span>
                    </div>
                    <h3 className="text-xl font-bold text-[#17254e] mb-2">
                      {contact.title}
                    </h3>
                  </div>

                  {/* Primary Contact Info - Fixed for Email */}
                  <div className="text-center mb-4">
                    {contact.isEmail ? (
                      // Special handling for email addresses
                      <div className="space-y-2">
                        <div className="break-all">
                          <a
                            href={contact.clickable}
                            className="text-sm md:text-[13px] font-bold text-[#785dd7] hover:text-[#674ecf] transition-colors duration-300 hover:underline block leading-tight"
                          >
                            {contact.primary}
                          </a>
                        </div>
                        <div className="break-all">
                          <a
                            href={`mailto:${contact.secondary}`}
                            className="text-sm md:text-[13px] font-semibold text-slate-700 hover:text-[#785dd7] transition-colors duration-300 hover:underline block leading-tight"
                          >
                            {contact.secondary}
                          </a>
                        </div>
                      </div>
                    ) : contact.clickable ? (
                      // Regular clickable content
                      <>
                        <a
                          href={contact.clickable}
                          className="text-sm md:text-[13px] font-bold text-[#785dd7] hover:text-[#674ecf] transition-colors duration-300 hover:underline"
                        >
                          {contact.primary}
                        </a>
                        <p className="text-sm md:text-[13px] font-semibold text-slate-700 mt-1">
                          {contact.secondary}
                        </p>
                      </>
                    ) : (
                      // Non-clickable content
                      <>
                        <p className="text-sm md:text-[13px] font-bold text-[#785dd7]">
                          {contact.primary}
                        </p>
                        <p className="text-sm md:text-[13px] font-semibold text-slate-700 mt-1">
                          {contact.secondary}
                        </p>
                      </>
                    )}
                  </div>

                  {/* Details List */}
                  <div className="space-y-2 mb-6">
                    {contact.details.map((detail, idx) => (
                      <div
                        key={idx}
                        className="flex items-start gap-3 text-sm text-slate-600"
                      >
                        <div className="w-2 h-2 bg-[#785dd7] rounded-full flex-shrink-0 mt-1.5"></div>
                        <span className="text-left leading-relaxed">
                          {detail}
                        </span>
                      </div>
                    ))}
                  </div>

                  {/* Action Button */}
                  {contact.clickable && (
                    <div className="mt-auto">
                      <a
                        href={contact.clickable}
                        className={`w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-2xl bg-gradient-to-r ${contact.gradient} hover:bg-gradient-to-r hover:${contact.hoverGradient} text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5 text-sm`}
                      >
                        <span>
                          {contact.title === "Phone Contact"
                            ? "Call Now"
                            : contact.title === "Email Contact"
                            ? "Send Email"
                            : "Visit Website"}
                        </span>
                        <span className="transition-transform duration-300 group-hover:translate-x-1">
                          →
                        </span>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Enhanced Contact Form Section */}
          {/* <div className="max-w-4xl mx-auto">
              <div className="group relative">
                <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-white/10 rounded-3xl blur opacity-50"></div>

                <div className="relative bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/20 shadow-2xl">
                  <div className="text-center mb-8">
                    <h3 className="text-3xl font-bold mb-4">Send us a Message</h3>
                    <p className="text-white/80">
                      Have questions about sponsorship or registration? Drop us a
                      line and we'll get back to you.
                    </p>
                  </div>

                  <form className="space-y-6">
                    <div className="grid md:grid-cols-2 gap-6">
                      <div className="group/input">
                        <label className="block text-sm font-medium text-white mb-2">
                          Full Name *
                        </label>
                        <input
                          type="text"
                          className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/30 focus:border-white/40 transition-all duration-300 backdrop-blur-sm"
                          placeholder="Enter your name"
                          required
                        />
                      </div>
                      <div className="group/input">
                        <label className="block text-sm font-medium text-white mb-2">
                          Email Address *
                        </label>
                        <input
                          type="email"
                          className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/30 focus:border-white/40 transition-all duration-300 backdrop-blur-sm"
                          placeholder="your.email@example.com"
                          required
                        />
                      </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-6">
                      <div className="group/input">
                        <label className="block text-sm font-medium text-white mb-2">
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/30 focus:border-white/40 transition-all duration-300 backdrop-blur-sm"
                          placeholder="+91 12345 67890"
                        />
                      </div>
                      <div className="group/input">
                        <label className="block text-sm font-medium text-white mb-2">
                          Inquiry Type
                        </label>
                        <select className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white focus:outline-none focus:ring-2 focus:ring-white/30 focus:border-white/40 transition-all duration-300 backdrop-blur-sm">
                          <option value="">Select inquiry type</option>
                          <option value="sponsorship">Sponsorship</option>
                          <option value="registration">Registration</option>
                          <option value="speaker">Speaker Proposal</option>
                          <option value="media">Media Partnership</option>
                          <option value="general">General Inquiry</option>
                        </select>
                      </div>
                    </div>

                    <div className="group/input">
                      <label className="block text-sm font-medium text-white mb-2">
                        Message *
                      </label>
                      <textarea
                        rows="5"
                        className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/30 focus:border-white/40 transition-all duration-300 backdrop-blur-sm resize-none"
                        placeholder="Please share your inquiry details..."
                        required
                      ></textarea>
                    </div>

                    <div className="text-center">
                      <button
                        type="submit"
                        className="group/btn inline-flex items-center gap-3 bg-white text-[#785dd7] font-bold px-8 py-4 rounded-2xl hover:bg-white/90 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-white/30"
                      >
                        <svg
                          className="w-5 h-5 group-hover/btn:scale-110 transition-transform duration-300"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                          ></path>
                        </svg>
                        <span>Send Message</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div> */}

          {/* Quick Contact Info */}
          {/* <div className="mt-16 text-center">
              <div className="inline-flex flex-wrap justify-center items-center gap-8 bg-white/10 backdrop-blur-sm rounded-2xl px-8 py-6 border border-white/20">
                <div className="flex items-center gap-2 text-white/90">
                  <span className="text-xl">⏰</span>
                  <span className="text-sm">Response within 24 hours</span>
                </div>
                <div className="flex items-center gap-2 text-white/90">
                  <span className="text-xl">🌏</span>
                  <span className="text-sm">Based in Chennai, India</span>
                </div>
                <div className="flex items-center gap-2 text-white/90">
                  <span className="text-xl">🤝</span>
                  <span className="text-sm">
                    Partnership opportunities available
                  </span>
                </div>
              </div>
            </div> */}
        </div>
      </section>
    </div>
  );
}
